/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Train_TodayInputs */

const en_us2_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train this one today`)
};

const pt_br2_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar este hoje`)
};

const es_419_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenar este hoy`)
};

const pt_pt2_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar este hoje`)
};

const fr_fr2_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire celle-ci aujourd'hui`)
};

const de_de2_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute dieses trainieren`)
};

const it_it2_plan_edit_train_today = /** @type {(inputs: Plan_Edit_Train_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai questo oggi`)
};

/**
* | output |
* | --- |
* | "Train this one today" |
*
* @param {Plan_Edit_Train_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_train_today = /** @type {((inputs?: Plan_Edit_Train_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Train_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_train_today(inputs)
	if (locale === "es-419") return es_419_plan_edit_train_today(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_train_today(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_train_today(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_train_today(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_train_today(inputs)
	return en_us2_plan_edit_train_today(inputs)
});
export { plan_edit_train_today as "plan-edit.train_today" }